<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <main class="main-wrapper flex-grow-1">
      <div class="d-flex align-items-center bg-white">
        <div
            class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
          {{ $t('1746') }}
        </div>
      </div>
      <div class="divider"></div>
      <div class="container container--narrow">
        <div class="t-body3 t-color-bodyGrayA l-spacing42 mgt-30 mgb-16 font-r">{{ $t('1747') }}</div>
        <div class="mdc-card">
          <ul class="mdc-list mdc-list--two-line list-with-default-cursor">
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1748')
                  }}</span>
                  <span
                      class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                      (personalInfo && personalInfo.name) ? $t('3437', {
                        first: personalInfo.name.first,
                        last: personalInfo.name.last
                      }) : ''
                    }}</span>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15 cursor-pointer" tabindex="0" @click="openPattenDialog" @keypress="openPattenDialog">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1749')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-signBlue">{{
                    $t('1750')
                  }}</span>
              </span>
              <span v-if="profileImage" aria-hidden="true" class="mdc-list-item__meta">
                <UserImgProfile :data="personalInfo" :size="'s'" :className="'mgr-0'" />
              </span>
              <span v-else :style="bgColorOfName" aria-hidden="true"
                    class="mdc-list-item__meta min-w-40 h-40 user-name-profile" v-html="firstCharOfNames">
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1751')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    personalInfo ? personalInfo.userId : ''
                  }}</span>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>

            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15  cursor-pointer" tabindex="0" @click="addMobileNo" @keypress="addMobileNo">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1752')
                  }}</span>
                <span
                    v-if="phoneNo && phoneNo.country"
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                  phoneNo.fullPhoneNumber
                  }}</span>
                <span
                    v-else
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-signBlue">{{
                  $t('1753')
                  }}</span>
              </span>
              <span aria-hidden="true" class="mdc-list-item__meta">
                <button class="mdc-icon-button material-icons mgr--12 rtl-support"
                        data-mdc-ripple-is-unbounded=""
                        title="">chevron_right</button>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15  cursor-pointer" tabindex="0" @click="addDateOfBirth" @keypress="addDateOfBirth">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1947')
                  }}
                </span>
                <span
                    v-if="personalInfo && personalInfo.birth"
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    $moment(personalInfo.birth).format("L")
                  }}</span>
                <span
                    v-else
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-signBlue">{{
                    $t('1948')
                  }}</span>
              </span>
              <span aria-hidden="true" class="mdc-list-item__meta">
                <button class="mdc-icon-button material-icons mgr--12 rtl-support"
                        data-mdc-ripple-is-unbounded=""
                        title="">chevron_right</button>
              </span>
            </li>
          </ul>
        </div>
        <div class="t-body3 t-color-bodyGrayA l-spacing42 mgt-24 mgb-16 font-r">{{ $t('1754') }}</div>

        <div class="mdc-card">
          <ul class="mdc-list mdc-list--two-line list-with-default-cursor">
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1755')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    personalInfo ? personalInfo.dutyName : ''
                  }}</span>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>

            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1756')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    personalInfo ? personalInfo.responsibilityName : ''
                  }}</span>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1757')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    personalInfo ? personalInfo.storeName : ''
                  }}</span>
              </span>
            </li>
            <li class="mdc-list-divider mgl-24 mgr-24" role="separator"></li>

            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
                <span
                    class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                    $t('1758')
                  }}</span>
                <span
                    class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-headlineBlack">{{
                    personalInfo ? personalInfo.storeCode : ''
                  }}</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="t-body3 t-color-bodyGrayA l-spacing42 mgt-24 mgb-16 font-r">{{ $t('3501') }}</div>
        <div class="mdc-card">
          <ul class="mdc-list mdc-list--two-line list-with-default-cursor">
            <li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-15" tabindex="0" @click="goToAccountWithdrawal" @keypress="goToAccountWithdrawal">
              <span class="mdc-list-item__ripple"></span>
              <span class="mdc-list-item__text">
										<span class="mdc-list-item__primary-text t-color-bodyGrayA font-r l-spacing42 t-body6">{{
                        $t('3512')
                      }}</span>
										<span class="mdc-list-item__secondary-text font-r l-spacing42 t-body1 t-color-signBlue">{{
                        $t('3513')
                      }}</span>
									</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="pdb-50"></div>
    </main>
    <profile-photo-type></profile-photo-type>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import {MDCDialog} from '@material/dialog';
import {MDCRipple} from '@material/ripple';
import memberApi from '@/api/memberApi.js';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import ProfilePhotoType from "@/components/common/ProfilePhotoType";

export default {
  name: 'MemberDetail',

  data() {
    return {
      personalInfo: null,
      profileImage: null,
      phoneNo: null,
      firstCharOfNames: localStorage.getItem('firstChar'),
      bgColorOfName: localStorage.getItem('bgColors'),
    }
  },

  mounted() {
    this.fatchData()
    this.setMaterialUi()
    this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
    this.pattenDialog.listen('MDCDialog:opened', () => {
    })
  },

  components: {
    TopAppBarDrawer,
    'profile-photo-type': ProfilePhotoType,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  methods: {
    fatchData() {
      memberApi.getMemberInfo().then((response) => {
        this.personalInfo = response.data.data
        this.profileImage = this.personalInfo ? this.personalInfo.profile : ''
        this.phoneNo = this.personalInfo ? this.personalInfo.phone : ''
      })
    },

    goToAccountWithdrawal() {
      // 2023-11-20 jaehyub.lee@emcast.com 탈퇴 임시 처리
      this.$router.push({
        name: "Withdrawal",
      });
    },

    openPattenDialog() {
      this.pattenDialog.open()
    },

    addMobileNo() {
      this.$router.push('myphone')
    },

    addDateOfBirth() {
      this.$router.push({
        name: "MemberDOB",
      })
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  }
}
</script>
